import { toPlainText } from '@portabletext/vue'
import type { GQLBlock } from '@core/types/generated/text'

export const INVALID_PLACEHOLDER_VALUE = '---INVALID VALUE--'

export function hasInvalidPlaceholderValue(text: string | GQLBlock[] | undefined | null) {
  if (!text) {
    return false
  }
  if (typeof text === 'string') {
    return text.includes(INVALID_PLACEHOLDER_VALUE)
  }
  return toPlainText(text).includes(INVALID_PLACEHOLDER_VALUE)
}
